import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const BoxArtModal = ({ isOpen, toggle, imgUrl, gameName }) => {
  // Generate unique IDs for accessibility
  const modalId = 'box-art-preview-modal'
  const modalTitleId = 'box-art-preview-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="global.label.previewBoxArt" />
        </h2>
        <div className="text-center">
          <img
            src={imgUrl}
            className="summary-activation-content-image"
            alt={gameName ? `${gameName} box art` : 'Game box art'}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button
                block
                outline
                color="light"
                onClick={toggle}
                aria-label="Close box art preview"
              >
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

BoxArtModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  imgUrl: PropTypes.string.isRequired,
  gameName: PropTypes.string,
}

BoxArtModal.defaultProps = {
  gameName: '',
}

export default BoxArtModal
